// extracted by mini-css-extract-plugin
module.exports =  {"videoBox":"videoBox__N-Zgs"};